module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_b_66-c2987d.svg";